import React from 'react'
import { Container, Col, Row, Image } from "react-bootstrap";
import bigdiamond from '../../../Assets/images/cultbrilliance/about-side.jpg'
const AtculturedBrilliance = () => {
  return (
   <>
<section className='cbr_at_cultured'>
<Container fluid >
<Row className='no-gutters'>
<Col md={12} sm={12} lg={6} className=' g-0 back_telgreen'>
<div className='cbr_clustred_we_strive'>
    <div className='cbr_we_striv_text'>
       <h3>At Cultured Brilliance, we strive to:</h3>
       <ul className="listing">
                        <li> Be a leading jeweler for cultured diamonds</li>
                        <li> Source the best lab created diamonds and mountings</li>
                        <li> Deliver high quality pieces at affordable prices</li>
                        <li> Achieve and maintain 5.0 customer rating</li>
                    </ul>
                    <p>We can only achieve this with the support from our valued partners, advisors, and most of all our<br/> cherished customers. 
                        It’s thanks to all of you that we are a successful company.</p>
    </div>
</div>
</Col>
<Col md={12} sm={12} lg={6}  className='g-0'>
<div className='cbr_clustred_img'>  
<img src={bigdiamond} alt='At Cultured Brilliance, we strive to:' className="img-fluid"/>
</div>
</Col>
</Row>

</Container>
</section>
<section className='cbr_dimfd'> 
<Container fluid>
<div className='cbr_a_diamond_is_a_diamond'>
<Row>
<Col md={12} sm={12} lg={8} className='text-center m-auto' >
    <div className='cbr_oxward'>
        <p>A diamond is defined as a precious stone consisting of a clear and colorless crystalline form of pure carbon. 
        <em data-uw-styling-context="true">Oxford Dictionaries</em>
            {/* – Oxford Dictionaries */}
            </p>
        <br/>
    </div>
    <div className='cbr_a_diamond_laboratory'>
        <h3> A diamond is a diamond</h3>
        <p>Laboratory created diamonds are chemically, physically and optically identical to diamonds that are taken from the earth. 
            Identical, except for time to create and price for the consumer. Lab diamonds, aka “Cultured Diamonds”, are grown from a 
            carbon seed in a lab under conditions that mimic the effects of millions of years of being under the earth. 
            The carbon seed grows into a diamond rough. 
            The rough is then analyzed and cut using the same methodology as mined diamonds.</p>
    </div>
</Col>
</Row>
</div>
</Container>
</section>
   </>
  )
}

export default AtculturedBrilliance
